import React, { useState } from "react";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { IoMdArrowDropdown, IoMdArrowDropup } from "react-icons/io";
import CardTables from "../../../../atoms/CardTables";
import Modal from "../../../../molecules/Modal";
import ModalConfirm from "../../../../molecules/ModalConfirm";
import useModal from "../../../../../hooks/useModal";
import { GET_FILE } from "../../../../../api/apiFiles";
import { useSession } from "../../../../../context/SessionContext";
import ModalUpdateFile from "./ModalUpdateFile";
import { updateDocuments } from "../../../../../functions/updateDocuments";
import FilePreviewModal from "./FilePreviewModal";
import DateFilter from "./DateFilter";
import DocumentTable from "./DocumentTable";
import DeletedDocumentsTable from "./DeletedDocumentsTable";
import { useFilteredDocuments } from "../../../../../hooks/useFilteredDocuments";
import ModalEditDate from "./ModalEditDate";

const TableDocuments = ({ data, loading, empresa, refetch, documentos, tabla, types }) => {
    const { id, tipo } = useParams();
    const { user } = useSession();
    const [startDate, setStartDate] = useState("");
    const [endDate, setEndDate] = useState("");
    const { open, close, isOpen } = useModal();
    const { open: openDelete, close: closeDelete, isOpen: isOpenDelete } = useModal();
    const { open: openUpload, close: closeUpload, isOpen: isOpenUpload } = useModal();
    const { open: openEliminados, close: closeEliminados, isOpen: isOpenEliminados } = useModal();
    const { open: openDeleteMulti, close: closeDeleteMulti, isOpen: isOpenDeleteMulti } = useModal();
    const { open: openEditDate, close: closeEditDate, isOpen: isOpenEditDate } = useModal();
    const [loading2, setLoading2] = useState(false);
    const [documento, setDocumento] = useState();
    const [expandedRowKey, setExpandedRowKey] = useState(null);
    const [expandedRowKeyDeleted, setExpandedRowKeyDeleted] = useState(null);
    const { padresActivos, eliminados } = useFilteredDocuments(data, startDate, endDate);
    const [type, setType] = useState();

    const toggleEliminados = () => { 
        if (isOpenEliminados) { 
            closeEliminados(); 
        } else { 
        openEliminados(); 
        } 
    };

    const handleRowExpandToggled = (expanded, row) => { 
        if (expanded) { 
            setExpandedRowKey(row.key); 
        } else { 
            setExpandedRowKey(null); 
        } 
    };

    const handleRowExpandToggledDeleted = (expanded, row) => { 
        if (expanded) { 
            setExpandedRowKeyDeleted(row.key); 
        } else { 
            setExpandedRowKeyDeleted(null); 
        } 
    };

    const handleOpenDocument = async(s3Key, typeFile) => {
        try {
            const response = await GET_FILE(id, {s3Key});
            setDocumento(response);
            setType(typeFile);
            open();
        } catch (error) { console.error(error); toast.error("Error al obtener el archivo"); }
    };

    const handleOpenDeleteMulti = (documents) => { 
        setDocumento(documents); openDeleteMulti(); 
    };

    const handleDeleteMultiple = async () => {
        try {
            setLoading2(true);
            const previousDocs = documentos[tipo] || [];
            const updatedDocs = previousDocs.map(doc => {
                if (doc.key === documento.key) {
                    const updatedArchivos = doc.archivos.map(file => ({
                        ...file,
                        activo: false,
                        user: user?.roleInfo?.name || "Desconocido",
                    }));
                    return {
                        ...doc,
                        activo: false,
                        archivos: updatedArchivos,
                    };
                }
                return doc;
            });
            const updatePayload = { [tipo]: updatedDocs };
            await updateDocuments(tabla, empresa.type, documentos.id, updatePayload);
            toast.success("Documentos eliminados correctamente");
            refetch();
            closeDeleteMulti();
        } catch (error) { 
            console.error(error); 
            toast.error("Error al eliminar múltiples documentos");
        } finally { 
            setLoading2(false); 
        }
    };

    const handleOpenDelete = (document) => { 
        setDocumento(document); openDelete(); 
    };

    const handleDeleteDocument = async () => {
        try {
            setLoading2(true);
            const previousDocs = documentos[tipo] || [];
            const updatedDocs = previousDocs.map(doc => {
                if (doc.key === documento.primaryKey) {
                    const updatedArchivos = doc.archivos.flatMap(file => {
                        if (file.s3Key === documento.s3Key) {
                            const fileDesactivado = {
                                ...file,
                                user: user?.roleInfo?.name || "Desconocido",
                                activo: false,
                            };
                            const fileNuevo = {
                                s3Key: null,
                                filename: null,
                                title: file.title,
                                typeFile: file.typeFile,
                                user: user?.roleInfo?.name || "Desconocido",
                                primaryKey: file.primaryKey,
                                activo: true,
                                uniqueFile: file.uniqueFile,
                            };
                    
                            return [fileDesactivado, fileNuevo];
                        }
                        return [file];
                    });
                    
                    return {
                        ...doc,
                        archivos: updatedArchivos
                    };
                }
                return doc;
            });
            const updatePayload = { [tipo]: updatedDocs };
            await updateDocuments(tabla, empresa.type, documentos.id, updatePayload);
            refetch();
            closeDelete();
            toast.success("Archivo eliminado correctamente");
        } catch (error) { 
            console.error(error); 
            toast.error("Error al eliminar el archivo");
        } finally { 
            setLoading2(false); 
        }
    };

    const handleDownloadDocument = async (s3Key) => {
        try {
            setLoading2(true);
            const fileUrl = await GET_FILE(id, { s3Key });
                const response = await fetch(fileUrl);
                const blob = await response.blob();
                const blobUrl = window.URL.createObjectURL(blob);
                const link = document.createElement("a");
                link.href = blobUrl;
                link.download = s3Key;
                document.body.appendChild(link);
                link.click();
                link.remove();
                window.URL.revokeObjectURL(blobUrl);
                toast.success("Descargando");
        } catch (error) { 
            console.error(error); 
            toast.error("Error al descargar el archivo"); 
        } finally {
            setLoading2(false);
        }
    };

    const handleOpenUpload = (document) => { 
        setDocumento(document); 
        openUpload(); 
    };

        const handleOpenEditDate = (document) => {
        setDocumento(document);
        openEditDate();
    };

    const handleUpdateDate = async (newDate) => {
        try {
            setLoading2(true);
            const previousDocs = documentos[tipo] || [];
            
            const updatedDocs = previousDocs.map(doc => {
                if (doc.key === documento.key) {
                    // Actualizar títulos de archivos con la nueva fecha
                    const updatedArchivos = doc.archivos.map(file => {
                        if (file.title && file.activo) {
                            // Extraer el nombre base sin la fecha (ejemplo: "CONSTITUTIVA-2025-09-29" -> "CONSTITUTIVA")
                            const titleParts = file.title.split('-');
                            const baseName = titleParts[0]; // Toma solo la primera parte
                            const newTitle = `${baseName}-${newDate}`;
                            
                            return {
                                ...file,
                                title: newTitle,
                                user: user?.roleInfo?.name || "Desconocido",
                            };
                        }
                        return file;
                    });

                    return {
                        ...doc,
                        fecha: newDate,
                        archivos: updatedArchivos,
                    };
                }
                return doc;
            });

            const updatePayload = { [tipo]: updatedDocs };
            await updateDocuments(tabla, empresa.type, documentos.id, updatePayload);
            toast.success("Fecha actualizada correctamente");
            refetch();
            closeEditDate();
        } catch (error) {
            console.error(error);
            toast.error("Error al actualizar la fecha");
        } finally {
            setLoading2(false);
        }
    };

    return (
        <div className="space-y-6">
            <CardTables>
                <DateFilter startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />
                <DocumentTable
                    padresActivos={padresActivos}
                    loading={loading}
                    loading2={loading2}
                    user={user}
                    expandedRowKey={expandedRowKey}
                    handleRowExpandToggled={handleRowExpandToggled}
                    handleOpenDeleteMulti={handleOpenDeleteMulti}
                    handleOpenDocument={handleOpenDocument}
                    handleDownloadDocument={handleDownloadDocument}
                    handleOpenEditDate={handleOpenEditDate}
                    handleOpenDelete={handleOpenDelete}
                    handleOpenUpload={handleOpenUpload}
                />
            </CardTables>
            <CardTables>
            <button onClick={toggleEliminados} className="flex flex-row space-x-4 bg-red-800 rounded-lg px-2 py-1 text-white justify-center items-center" >Eliminados {isOpenEliminados ? <IoMdArrowDropup size={30} /> : <IoMdArrowDropdown size={30} />} </button>
            {isOpenEliminados &&
                <DeletedDocumentsTable
                    eliminados={eliminados}
                    loading={loading}
                    loading2={loading2}
                    expandedRowKeyDeleted={expandedRowKeyDeleted}
                    handleRowExpandToggledDeleted={handleRowExpandToggledDeleted}
                    handleOpenDocument={handleOpenDocument}
                    handleDownloadDocument={handleDownloadDocument}
                />
            }
            </CardTables>
            <FilePreviewModal isOpen={isOpen} onClose={close} documentUrl={documento} fileType={type} />
            {isOpenDelete && <ModalConfirm onClose={closeDelete} onConfirm={handleDeleteDocument} eliminacion /> }
            {isOpenDeleteMulti && <ModalConfirm onClose={closeDeleteMulti} onConfirm={handleDeleteMultiple} eliminacion /> }
            {isOpenUpload && 
                <Modal onClose={closeUpload} title="Subir documento" >
                    <ModalUpdateFile 
                        onClose={closeUpload} 
                        refetch={refetch} 
                        empresa={empresa} 
                        documentos={documentos} 
                        documento={documento} 
                        tipo={tipo} 
                        tabla={tabla} 
                    />
                </Modal>
            }
            {isOpenEditDate && 
                <Modal onClose={closeEditDate} title="Editar fecha del documento">
                    <ModalEditDate
                        onClose={closeEditDate}
                        documento={documento}
                        onConfirm={handleUpdateDate}
                        loading={loading2}
                    />
                </Modal>
            }
        </div>
    )
};

export default TableDocuments;